import "core-js/modules/es6.regexp.match";
import _slicedToArray from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
/**
 * @author tonicli
 * @date 2017/7/29
 */

var REG = /(\d+)(?:\.(\d+))?(?:\.(\d+))?(?:\.([\w-]+))?/;
var Version = /*#__PURE__*/function () {
  /**
   *@param {string} version
   */
  function Version(version) {
    _classCallCheck(this, Version);
    var _Version$parse = Version.parse(version),
      _Version$parse2 = _slicedToArray(_Version$parse, 4),
      major = _Version$parse2[0],
      minor = _Version$parse2[1],
      patch = _Version$parse2[2],
      build = _Version$parse2[3];
    this.major = major;
    this.minor = minor;
    this.patch = patch;
    this.build = build;
  }
  _createClass(Version, [{
    key: "toString",
    value: function toString() {
      var r = this.toArray();
      var breakPos = r.indexOf(undefined);
      return r.slice(0, breakPos > -1 ? breakPos : r.length).join('.');
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return [this.major, this.minor, this.patch, this.build];
    }
    /**
     *@param {Version|string} version
     *@param {Boolean} [greatAndEqual]
     */
  }, {
    key: "compare",
    value: function compare(version) {
      var greatAndEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var r1 = version instanceof Version ? version.toArray() : Version.parse(version);
      var r2 = this.toArray();
      for (var i = 0; i < r1.length; i++) {
        var v2 = r2[i] || 0;
        var v1 = r1[i] || 0;
        if (v2 !== v1) {
          return v2 > v1;
        }
      }
      return greatAndEqual;
    }
    /**
     *@param {Version|string} version
     */
  }, {
    key: "equal",
    value: function equal(version) {
      var _ref = version instanceof Version ? version.toArray() : Version.parse(version),
        _ref2 = _slicedToArray(_ref, 4),
        major = _ref2[0],
        minor = _ref2[1],
        patch = _ref2[2],
        build = _ref2[3];
      return this.major === major && this.minor === minor && this.patch === patch && this.build === build;
    }
    /**
     *@param {string} version
     */
  }], [{
    key: "parse",
    value: function parse(version) {
      var matches = version.match(REG);
      if (!matches) {
        throw new Error("[Version.parse]invalid version format(".concat(version, ")"));
      }
      return matches.slice(1).map(function (v) {
        var n = parseInt(v, 10);
        return isNaN(n) ? v : n;
      });
    }
    /**
     *@param {string} v1
     *@param {string} v2
     *@param {Boolean} [greatAndEqual]
     */
  }, {
    key: "compare",
    value: function compare(v1, v2) {
      var greatAndEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return new Version(v1).compare(v2, greatAndEqual);
    }
  }]);
  return Version;
}();
export { Version as default };